import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 2.75a9.75 9.75 0 1 0 9.75 9.75A9.76 9.76 0 0 0 12 2.75M6.945 19.016a6 6 0 0 1 10.11 0 8.234 8.234 0 0 1-10.11 0M9 11.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0m9.165 6.226a7.47 7.47 0 0 0-3.38-2.695 4.5 4.5 0 1 0-5.57 0 7.47 7.47 0 0 0-3.38 2.695 8.25 8.25 0 1 1 12.33 0"
    }, null, -1)
  ])))
}
export default { render: render }